import { keyframes, css, } from 'styled-components'
import { Transition } from './transitions'

const toModalName = "to-modal"
const duration = (typeof localStorage !== "undefined" && localStorage.transitionTimeout && parseInt(localStorage.transitionTimeout)) || 300
export const moveToBottom = keyframes`
    to {
        transform: translateY(100%);
    }
`

export const moveFromBottom = keyframes`
    from {
        transform: translateY(100%);
    }
`

export const scaleDown = keyframes`
    to {
        opacity  : 0;
        transform: scale(.8);
    }
`

export const scaleUp = keyframes`
    from {
        opacity          : 0;
        transform        : scale(.8);
    }
`

export const moveFromRight = keyframes`
    from {
        transform        : translateX(100%);
    }
`

export const moveToLeft = keyframes`
    to {
        transform        : translateX(-100%);
    }
`

export const moveFromLeft = keyframes`
    from {
        transform        : translateX(-100%);
    }
`

export const moveToRight = keyframes`
    to {
        transform        : translateX(100%);
    }
`

const toPreviousName = "to-previous"
export const toPreviousTransitions = css`
    &.${toPreviousName}-enter {
        position: absolute;
        width: 100%;        
    }
    &.${toPreviousName}-enter-active {
        animation: ${moveFromLeft} ${duration}ms ease both;
    }
    &.${toPreviousName}-exit {      
    }    
    &.${toPreviousName}-exit-active{
        animation: ${moveToRight} ${duration}ms ease both;
    }
`

const toNextName = "to-next"
export const toNextTransitions = css`
    &.${toNextName}-enter {
        position: absolute;
        width: 100%;
    }
    &.${toNextName}-enter-active {
        animation: ${moveFromRight} ${duration}ms ease both;
    }
    &.${toNextName}-exit {
    }
    &.${toNextName}-exit-active{
        animation: ${moveToLeft} ${duration}ms ease both;
    }
`

export const toModalTransitions = css`
    &.${toModalName}-enter {
        z-index   : 6;
        visibility: visible;
    }
    &.${toModalName}-enter-active {
        animation: ${moveFromBottom} ${duration}ms ease both;
    }
    &.${toModalName}-exit {
        z-index: 5;
    }
    &.${toModalName}-exit-active{
        animation: ${scaleDown} ${duration}ms ease both;
    }
`

const fromModalName = "from-modal"
export const fromModalTransitions = css`
    &.${fromModalName}-enter {
        visibility: visible;
        z-index   : 5;
    }
    &.${fromModalName}-enter-active {
        animation: ${scaleUp} ${duration}ms ease both;
    }
    &.${fromModalName}-exit {
        z-index: 6;
    }
    &.${fromModalName}-exit-active{
        animation: ${moveToBottom} ${duration}ms ease both;
    }
`

export const allTransitions = css`
    ${toModalTransitions}
    ${fromModalTransitions}
    ${toNextTransitions}
    ${toPreviousTransitions}
`

export const NO_TRANSITION: Transition = {
    transitionName: '',
}

const ToModal = {
    transitionName: toModalName,
    transitionDuration: duration,
}

export const TRANSITION_TO_MODAL: Transition = ToModal

const fromModal = {
    transitionName: fromModalName,
    transitionDuration: duration,
}

export const TRANSITION_FROM_MODAL: Transition = fromModal

const toNext = {
    transitionName: toNextName,
    transitionDuration: duration,
}

export const TRANSITION_TO_NEXT: Transition = toNext


const toPrevious = {
    transitionName: toPreviousName,
    transitionDuration: duration,
}

export const TRANSITION_TO_PREVIOUS: Transition = toPrevious
